// My profile and Users & roles on the Lender Hub API (S-3, api-contract.md §1a). Shapes: firstfund-contracts/schemas/hub/
// my-profile, admin-user, user-made. The password and 2-step on go through the sign-in calls (lib/hubApi.ts auth).
import type { z } from 'zod'
import type { AdminUser as AdminUserSchema, MyProfile as MyProfileSchema, UserMade as UserMadeSchema } from '@/contract/schemas'
import { api } from '@/lib/hubApi'
import type { User } from '@/types'

export type MyProfile = z.infer<typeof MyProfileSchema>
export type AdminUser = z.infer<typeof AdminUserSchema>
export type UserMade = z.infer<typeof UserMadeSchema>
export type Role = User['role']

export const profile = {
  get: () => api<MyProfile>('GET', '/me'),
  rename: (name: string) => api<MyProfile>('PATCH', '/me', { name }),
  newRecoveryCodes: (code: string) => api<{ recovery_codes: string[] }>('POST', '/me/2-step/recovery-codes', { code }),
  twoStepOff: (password: string, code: string) => api<MyProfile>('POST', '/me/2-step/off', { password, code }),
  endSession: (id: string) => api<MyProfile>('DELETE', `/me/sessions/${id}`),
  signOutOthers: () => api<MyProfile>('POST', '/me/sessions/sign-out-others', {}),
}

export const users = {
  list: () => api<AdminUser[]>('GET', '/users'),
  add: (body: { email: string; name: string; role: Role }) => api<UserMade>('POST', '/users', body),
  update: (id: string, body: { name?: string; role?: Role; active?: boolean }) => api<AdminUser>('PATCH', `/users/${id}`, body),
  resetPassword: (id: string) => api<UserMade>('POST', `/users/${id}/reset-password`, {}),
  resetTwoStep: (id: string) => api<AdminUser>('POST', `/users/${id}/reset-2-step`, {}),
}

/** The five roles, what each may do in plain words (the permissions are in store/devStore PERMISSIONS = api2 roles.js). */
export const ROLES: { id: Role; label: string; can: string }[] = [
  { id: 'admin', label: 'Admin', can: 'everything: users, settings and keys, Make live, activate / switch off lenders' },
  { id: 'editor', label: 'Editor', can: 'edit lenders and products, write code and workflows, run tests and UAT calls' },
  { id: 'reviewer', label: 'Reviewer', can: 'read everything, run tests, sign off a version in the app checks' },
  { id: 'analyst', label: 'Analyst', can: 'read only: lenders, code, runs, endpoints, alerts, usage' },
  { id: 'mis_uploader', label: 'MIS uploader', can: "the lenders' MIS only: upload, map, check and apply files; Not matched, Missing from MIS" },
]
